module.exports = __webpack_public_path__ + "img/sezer.c2dfc0c3.jpg";